// @flow

export default {
  wizard: {
    next: 'التالي',
    back: 'خلف',
    skip: 'يتخطى',
    sort: 'فرز',
    sorting: {
      'utility:desc': 'أفضل نتيجة',
      'price:asc': 'السعر الصعود',
      'price:desc': 'السعر الهزلي',
      'created_at:desc': 'أحدث',
      'customer_rating:desc': 'تقييم العملاء'
    },
    clickToAddFiles: 'انقر لإضافة ملفاتك أو إسقاطها هنا.',
    searchFor: 'بحث عن ...',
    noSearchResults: 'لسوء الحظ لم نعثر على أي خيارات مناسبة. الرجاء البحث مرة أخرى.',
    loadMoreAnswerOptions: 'لا يوجد خيار مناسب هنا؟ عرض جميع الخيارات.',
    noRecommendationDescription: 'أوه لا ، للأسف لم نتمكن من العثور على أي منتجات تناسب احتياجاتك.',
    noRecommendationDescription2: 'يرجى إعادة تشغيل مستشار المنتج.',
    noRecommendationRestartButtonTitle: 'إعادة تشغيل',
    noRecommendationCloseButtonTitle: 'يغلق',
    removeFile: 'إزالة الملف'
  },
  chatbot: {
    selectAll: 'اختر الكل',
    none: 'لا أحد',
    confirmButton: 'يتأكد',
    customerServiceInputPlaceholder: 'اكتب رسالة ...',
    you: 'أنت',
    restart: 'ابدأ مرة أخرى',
    close: 'يغلق',
    send: 'يرسل',
    supportChat: 'دردشة الدعم',
    honeypot: 'يرجى ترك هذا الحقل فارغا',
    scrollToTheLatestMessage: 'مرِّر إلى أحدث رسالة',
    removeFile: 'إزالة الملف'
  },
  product: {
    loadMore: 'تحميل المزيد من المنتجات',
    badgeTitle: 'اقتراحنا',
    ctaButtonTitle: 'للمنتج',
    matchingPanelTitle: 'معدّ بما يلائمكم:',
    bestFit: 'الأنسب',
    bestPrice: 'افضل سعر',
    bestFitForPrice: 'أفضل قيمة مقابل المال',
    addToCartError: 'إضافة إلى العربة لم تكن ناجحة. حاول مرة اخرى',
    addRoutineToCart: 'أضف إلى السلة',
    explanationHeader: 'المزيد من معلومات المنتج:',
    emptyRoutineItem: 'لسوء الحظ ، لا يوجد منتج في تلك الفئة التي تطابق تفضيلاتك.'
  },
  tabBar: {
    chat: 'محادثة',
    productAdvisor: 'محادثة'
  },
  recommender: {
    answerOptionLeadsToNoRecommendation: 'لسوء الحظ ، لن يؤدي هذا الخيار إلى أي منتج مطلوب. يمكنك تغيير تفضيلاتك في الخطوات السابقة لتمكين الخيار.'
  }
}
